import * as React from "react";
import { CloseButtonStyle } from "./Styles";

export default function CloseButton({ label, onClick, icon, ariaText }) {
  return (
    <CloseButtonStyle
      component={"a"}
      variant="outlined"
      aria-label={typeof ariaText !== "undefined" ? ariaText : label}
      onClick={onClick}
      startIcon={icon}
    >
      {label}
    </CloseButtonStyle>
  );
}
